import { createFileRoute } from "@tanstack/react-router";
import { WireRequestsEscalations } from "@/components/WireRequestsEscalations";

function RouteComponent() {
  return <WireRequestsEscalations />;
}

export const Route = createFileRoute("/_authenticated/wire-request-escalations/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
